import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { IotAddonGuard } from '../guards/iot-addon.guard';
import { PermissionGuard } from '../guards/permission.guard';
import { lazyRouteNamed } from '../lazy-route';

export const settingsRoutes: RouteObject[] = [
  {
    path: RoutesList.BILLING,
    element: <PermissionGuard permission="BILLING" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/settings/billing/billing-page'),
              'BillingPage',
            ),
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.CLOSING_DAYS,
    element: <PermissionGuard permission="SETTINGS" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/settings/closing-days/closing-days-page'),
              'ClosingDaysPage',
            ),
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.EMAIL_PREFERENCES,
    element: <PermissionGuard permission="SETTINGS" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/settings/email-notifications/email-notifications-page'),
              'EmailNotificationsPage',
            ),
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.LABEL_FORMAT,
    element: <PermissionGuard permission="SETTINGS" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/settings/label-format/label-format-page'),
              'LabelFormatPage',
            ),
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.COMPANY_PROFILE,
    element: <PermissionGuard permission="SETTINGS" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/settings/company-profile/company-profile-page'),
              'CompanyProfilePage',
            ),
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.FOOD_PRESETS,
    element: <PermissionGuard permission="EQUIPMENT" redirectTo={RoutesList.SETTINGS} />,
    children: [
      {
        path: '',
        element: <IotAddonGuard redirectTo={RoutesList.SETTINGS} />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/settings/food-presets/main-page'),
                  'FoodPresetsPage',
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.SETTINGS,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(() => import('../../pages/settings/main-page'), 'SettingsPage'),
      },
    ],
  },
];
